// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__7elq6","employee-header-item":"Header_employee-header-item__kxBvQ"};